<template>
  <!-- MODULE ADMIN STATS SECTION -->
  <v-flex
    class="pa-1"
    xs12
    sm6
    lg4
    xl3
    v-if="
      ($store.state.storeAuth.userProfile.isSuperAdmin &&
        $store.state.storeClient.client.basicSettings.name ==
          $store.state.storeAuth.userProfile.client &&
        ($store.state.storeClient.client.modules.modulePhotoOrder.active ||
          $store.state.storeClient.client.modules.modulePhotoGift.active)) ||
      $store.state.storeAuth.userProfile.isSuperStoreAdmin
    "
  >
    <v-card
      :class="
        getTheme() == 'dark'
          ? 'outlined elevation-0 primary'
          : 'flat elevation-0 primary'
      "
      :style="
        getTheme() == 'dark'
          ? 'border: 1px solid darkgray'
          : 'border-bottom: 1px solid lightgray'
      "
      style="height: 100%"
    >
      <!--<v-card-title
              :style="
                getTheme() == 'dark'
                  ? 'background-color: #505050'
                  : 'background-color: white; border-bottom: 1px solid lightgray'
              "
              :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
              class="title font-weight-regular"
            >
              <v-icon
                :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
                class="mr-3"
                medium
              >mdi-poll</v-icon>
              {{ $t("homeMenuAdminStatsMainTitle") }}
      </v-card-title>-->
      <v-card-text
        class="pa-0 ma-0"
        :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
        :style="
          getTheme() == 'dark'
            ? 'background-color: whitesmoke'
            : 'background-color: whitesmoke'
        "
      >
        <v-card color="primary" flat dark>
          <v-card-text>
            <div
              class="title font-weight-thin d-flex justify-center align-center"
            >
              <div
                v-if="
                  !isNaN($store.state.storeOrderDay.orderDay.orderNum) &&
                  Number($store.state.storeOrderDay.orderDay.orderNum >= 0)
                "
              >
                <div class="animated rubberBand" style="animation-delay: 6s">
                  <span class="mr-2">
                    {{ $t("homeMenuAdminStatsTodayTitle") }}
                  </span>
                  <v-icon
                    medium
                    color="rgba(255, 255, 255, .6)"
                    class="pb-1 mr-1"
                    >mdi-image-multiple</v-icon
                  >
                  <strong>
                    {{ $store.state.storeOrderDay.orderDay.orderNum }}
                  </strong>
                  /
                  <strong>
                    {{
                      price($store.state.storeOrderDay.orderDay.totalSumCart)
                    }}
                  </strong>
                </div>
              </div>
              <v-spacer></v-spacer>
              <div class="animated rubberBand" style="animation-delay: 7s">
                <v-icon medium color="rgba(255, 255, 255, .6)" class="pb-1"
                  >mdi-cart</v-icon
                >
                {{
                  !isNaN($store.state.storeCartWaiting.cartWaiting.totalNum) &&
                  Number(
                    $store.state.storeCartWaiting.cartWaiting.totalNum >= 0
                  )
                    ? $store.state.storeCartWaiting.cartWaiting.totalNum
                    : "0"
                }}
                /
                {{
                  !isNaN($store.state.storeCartWaiting.cartWaiting.totalNum) &&
                  Number(
                    $store.state.storeCartWaiting.cartWaiting.totalNum >= 0
                  )
                    ? getRawZipSize
                    : "0 B"
                }}
              </div>
            </div>
          </v-card-text>
          <v-card-text class="ma-0 pa-0 mb-2">
            <v-sheet color="primary">
              <div class="d-flex">
                <div
                  class="overline pt-2 pl-4"
                  style="color: rgba(255, 255, 255, 0.7)"
                >
                  {{ $t("homeMenuAdminStatsLastDaysTitle") }}
                </div>
                <v-spacer></v-spacer>
                <div
                  class="overline pt-2 pr-4"
                  style="color: rgba(255, 255, 255, 0.7); text-align: right"
                >
                  {{ $t("homeMenuAdminStatsLastMonthTitle") }}
                  <v-icon small color="rgba(255, 255, 255, .6)"
                    >mdi-image-multiple</v-icon
                  >
                  {{
                    !isNaN($store.state.storeOrderMonth.orderMonth.orderNum)
                      ? $store.state.storeOrderMonth.orderMonth.orderNum
                      : "0"
                  }}
                  /
                  {{
                    !isNaN($store.state.storeOrderMonth.orderMonth.totalSumCart)
                      ? price(
                          $store.state.storeOrderMonth.orderMonth.totalSumCart
                        )
                      : "0"
                  }}
                </div>
              </div>
              <v-sparkline
                v-if="$store.state.storeOrderDayFull.orderDayFull.length > 0"
                :value="updateAdminGraph"
                color="rgba(255, 255, 255, .7)"
                padding="24"
              >
                <template v-slot:label="item">{{ price(item.value) }}</template>
              </v-sparkline>
              <div v-else class="white--text ma-4 overline">
                {{ $t("homeMenuAdminStatsNoGraphTitle") }}
              </div>
            </v-sheet>
            <div
              v-if="$store.state.storeClient.client.pricing.active"
              class="pa-0 ma-0"
              style="font-size: 10px; font-weight: normal; text-align: center"
            >
              {{ $t("homeMenuAdminStatsCurrentSubscriptionAmountTitle") }}
              <span
                v-if="
                  $store.state.storeOrderMonth.orderMonth.totalSumCart <=
                  $store.state.storeClient.client.pricing.baseLimit
                "
                >{{
                  price($store.state.storeClient.client.pricing.basePrice)
                }}</span
              >
              <span
                v-else-if="
                  $store.state.storeOrderMonth.orderMonth.totalSumCart >
                  $store.state.storeClient.client.pricing.baseLimit
                "
                >{{
                  price(
                    $store.state.storeClient.client.pricing.basePrice +
                      ($store.state.storeOrderMonth.orderMonth.totalSumCart -
                        $store.state.storeClient.client.pricing.baseLimit) *
                        ($store.state.storeClient.client.pricing.overLimitPct /
                          100)
                  )
                }}</span
              >
            </div>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { formatBytes } from "@/mixins/utils";

export default {
  name: "homeMenuAdminStats",
  data: () => ({}),
  computed: {
    getRawZipSize() {
      return formatBytes(
        this.$store.state.storeCartWaiting.cartWaiting.rawZipSize,
        0
      );
    },
    updateAdminGraph() {
      let values = this.$store.state.storeOrderDayFull.orderDayFull;
      // če še ni 7 dni, moramo preveriti, da ne pišemo trenutnega dneva večkrat v array
      if (values.length == 6)
        values.push(this.$store.state.storeOrderDay.orderDay.totalSumCart);
      return values;
    },
  },
};
</script>
